export default __webpack_public_path__ + "static/media/monika.f5962fb3.JPG";